import React, {FC} from 'react'
import cls from "../forms.module.scss"
import {useDispatch, useSelector} from "react-redux";
import {setFormElementValue} from "../../../../store/formbuilder";
import {IState} from "../../../../types/state";
import ErrorMessages from "./ErrorMessages";

interface IProps {
    formId: number,
    index: number,
    element: {
        required: boolean,
        label: string,
        description: string,
        descriptionShow : boolean,
        placeholder: string,
        className: string,
        name: string,
        value: string,
        subtype: string,
        maxlength: number,
    }
}

const Input: FC<IProps> = (
    {
        formId,
        index,
        element: {
            required = false,
            label = "",
            description = "",
            descriptionShow = false,
            placeholder = "",
            className = "",
            name = "",
            value = "",
            subtype = "",
            maxlength,
        }
    }
) => {
    const reduxValue = useSelector((state: IState) => state.formBuilder.forms.find(el => el.id === formId)?.formData[index].value || "")
    const errors = useSelector((state: IState) => state.formBuilder.errors)
    const dispatch = useDispatch();

    const handleChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setFormElementValue({
            id: formId,
            index,
            fieldsForChange: {
                value: e.target.value
            }
        }))
    }

    const handleClasses = {
        true: `${className} ${cls.warning}`,
        false: className,
    }

    const handleRequired = {
        true: <span className={cls.required}>*</span>,
        false: null
    }

    const handleDescription = {
        true: <div className={cls.description}>
            <span>?</span>
            <div className={cls.info_text}>{description}</div>
        </div>,
        false: null
    }
    const inputType = className.includes('number_type') ? "number" : subtype;

    return <div className={cls.form_input}>
        <div className={cls.label}>
            <label htmlFor={name}>
                {label}
            </label>
            {handleRequired[`${required}`]}
            {handleDescription[`${descriptionShow}`]}
        </div>
        <input
            id={name}
            name={name}
            type={inputType}
            className={handleClasses[`${!!errors[name]}`]}
            placeholder={placeholder}
            value={reduxValue}
            maxLength={maxlength}
            onChange={handleChangeValue}
        />
        <ErrorMessages errors={errors[name]}/>
    </div>
}
export default Input
